<script>
import * as def from '@/lib/definition'
import { getSize } from '@/lib/common'
export default {
  props: {
    maxSize: {
      type: Number,
      default: 1024 ** 2 * 1
    }
  },
  data: () => ({
    imageSource: null,
    file: null
  }),
  methods: {
    loadImage (e) {
      this.file = e.srcElement.files[0]
      this.file.ext = this.file.name.match(/[^.]*$/, '')[0]
      const fr = new FileReader()
      fr.addEventListener('load', () => {
        this.file.blob = new Blob(
          [fr.result],
          { type: def.ext2mime[this.file.ext] }
        )
        this.imageSource = window.URL.createObjectURL(this.file.blob)
      })
      fr.readAsArrayBuffer(this.file)
    },
    save () {
      this.$emit('load', this.file)
    },
    getSize (size) {
      return getSize(size)
    }
  }
}
</script>

<template>
  <div
    class="image-file-loader"
    @click="$emit('cancel')"
  >
    <div
      @click.stop
      class="container"
    >
      <div
        class="has-text-align-center image"
        v-if="imageSource"
      >
        <img
          :src="imageSource"
          class="image-source"
          ref="img"
        >
      </div>
      <nav class="level-left">
        <input
          @change="loadImage"
          class="button"
          type="file"
        >
        <span  v-if="imageSource">{{ getSize(file.size) }}</span>
        <button
          v-if="imageSource"
          @click.stop="save"
          :disabled="!imageSource || file.size > maxSize"
          class="button"
        >
          <i class="material-icons">check_circle</i>
          <span>選択したファイルを追加する</span>
        </button>
        <button
          @click.stop="$emit('cancel')"
          class="icon cancel"
        >
          <i class="material-icons is-size-0">cancel</i>
        </button>
      </nav>
      <div class="notice">
        <p class="is-size-5">※画像ファイルの容量は{{ getSize(maxSize) }}までです。</p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
.image-file-loader {
  z-index: 5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  .container {
    position: relative;
    padding: 1rem;
    border-radius: .5rem;
    background-color: variables.$black-light;
    nav {
      > * {
        margin: 0 .5rem;
      }
    }
    .image {
      margin-bottom: 1rem;
    }
    img {
      max-width: 50vw;
      max-height: 50vh;
      background-image:
        repeating-linear-gradient( 0deg, #999 0px 1px, transparent 1px 10px),
        repeating-linear-gradient( 90deg, #999 0px 1px, transparent 1px 10px);
    }
    button {
      color: white;
    }
    .cancel {
      position: absolute;
      top: -1rem;
      right: -1rem;
    }
    .notice {
      margin: 1rem 1rem 0;
    }
  }
}
</style>
